import type { IChatLikes } from "./chat-model";

export class ChatLikes {
  public messagesLikesMap: Record<string, IChatLikes> = {};

  public likeMessage(messageId: string, liked: boolean): void {
    const previousState = this.messageOrDefault(messageId);
    const updatedState = { ...previousState, isLiked: liked };

    if (updatedState.likes > 0) {
      const dir = liked ? 1 : -1;
      updatedState.likes += dir;
    } else if (liked) {
      updatedState.likes = 1;
    }

    this.messagesLikesMap[messageId] = updatedState;
  }

  public updateMessageLikeMetadata(
    messageId: string,
    next: Partial<IChatLikes>,
  ): void {
    const previousState = this.messageOrDefault(messageId);
    this.messagesLikesMap[messageId] = {
      isLiked: next.isLiked ?? previousState.isLiked,
      likes: next.likes ?? previousState.likes,
    };
  }

  public setAbsoluteCount(messageId: string, total: number): void {
    const previous = this.messageOrDefault(messageId);
    this.messagesLikesMap[messageId] = { ...previous, likes: total };
  }

  public removeMessageLikes(messageId: string): void {
    delete this.messagesLikesMap[messageId];
  }

  public clear(): void {
    this.messagesLikesMap = {};
  }

  protected messageOrDefault(messageId: string): IChatLikes {
    return this.messagesLikesMap[messageId] ?? { isLiked: false, likes: 0 };
  }
}
